/* ==========================================================================
   ModalOrigins > Client > Config
   ========================================================================== */

/* Config */
const config = {
    type: {
        modal: 'modal-origins'
    },
    css: {
        modal: 'modal--origins'
    }
};

/* Exports */
module.exports = () => config;
